import State from '../core/State';
import { SalesData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSalesByVisitor = () =>
  produce((draft: Draft<State>) => {
    draft.salesByVisitor.fetching = draft.salesByVisitor.fetching + 1;
  });

export const setSalesByVisitor = (salesData: SalesData) =>
  produce((draft: Draft<State>) => {
    draft.salesByVisitor.data = salesData;
  });

export const finishFetchingSalesByVisitor = () =>
  produce((draft: Draft<State>) => {
    draft.salesByVisitor.fetching = draft.salesByVisitor.fetching - 1;
  });

export const disposeSalesByVisitor = () =>
  produce((draft: Draft<State>) => {
    draft.salesByVisitor.data = initialState.salesByVisitor.data;
    draft.salesByVisitor.fetching = initialState.salesByVisitor.fetching;
  });
